export interface RootWindow extends Window {
  rootWindow: RootWindow;
  parent: RootWindow;
  System: {
    import: (path: string) => Promise<any>;
    getRegister: Function;
    instantiate: Function;
    set: Function;
  };
  VERSIONS?: { [key: string]: string };
}

export const getRootWindow = (): RootWindow => {
  const win: RootWindow = window as any;
  return win.rootWindow || win.parent.rootWindow || win;
};
